import { render, staticRenderFns } from "./DuelTranscript.vue?vue&type=template&id=0c54f0df&scoped=true"
import script from "./DuelTranscript.vue?vue&type=script&lang=js"
export * from "./DuelTranscript.vue?vue&type=script&lang=js"
import style0 from "./DuelTranscript.vue?vue&type=style&index=0&id=0c54f0df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c54f0df",
  null
  
)

export default component.exports